import { Diamond } from "lucide-react";
import Marquee from "react-fast-marquee";

const ITEMS = [
  "Human-in-the-Loop Architecture",
  "AI Exception Handling",
  "Lean Six Sigma",
  "WalkMe In-App Guidance",
  "MBTI & FIRO",
  "Instructional Design",
  "Behavioral Alignment",
  "KPI-Linked Escalations",
];

export default function MarqueeRibbon() {
  return (
    <div
      data-testid="editorial-marquee-ribbon"
      className="border-y border-[#E2E8F0] bg-white py-5"
    >
      <Marquee speed={42} gradient={false} pauseOnHover={true} className="mask-fade-x">
        {ITEMS.map((item) => (
          <span key={item} className="flex items-center">
            <span className="px-8 font-mono text-xs uppercase tracking-[0.3em] text-[#626D7D]">
              {item}
            </span>
            <Diamond className="h-2.5 w-2.5 fill-[#EB5E28] text-[#EB5E28]" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
